import type { ApplicationEdition } from '@jira/platform__application-editions/src/edition.tsx';
import type { TenantContext } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import {
	type ApplicationKey,
	SOFTWARE,
	SERVICE_DESK,
} from '@jira/platform__application-editions/src/application-key.tsx';

export const getProductEdition = (
	product: ApplicationKey,
	tenantContext: TenantContext,
): ApplicationEdition => {
	if (product === SOFTWARE) {
		return tenantContext.appEditions.software;
	}
	if (product === SERVICE_DESK) {
		return tenantContext.appEditions.serviceDesk;
	}

	return tenantContext.appEditions.core;
};
